import axios from "axios";
import { setupAuthInterceptor } from "./setupAuthInterceptor";
import { BASE_URL_API } from "../constants";

const api = axios.create({
	baseURL: BASE_URL_API,
});

setupAuthInterceptor(api);

export default api;
